import { IScheduleSectionFormValues } from '@src/features/shift-post-v2/steps/shift-details-step/components/schedule-section/schedule-section.types'
import { debounce } from '@src/helpers/helperFuncs'
import { setNumberTo2DecimalsOnly } from '@src/helpers/numberHelpers'
import { updateDays } from '@src/helpers/shiftHelpers'
import { TDay, TSingleDayShift } from '@src/helpers/shiftHelpers/types'
import { FormikProps } from 'formik'

/**
 * A function that performs pay value update for each gig day
 * @param payValue
 * @param multidayDays
 * @param toHireDays
 * @param setFieldValue
 */
const updatePayValueToGigDays = (
  payValue: string,
  multidayDays: TDay[],
  toHireDays: TDay[],
  setFieldValue: (
    field: string,
    value: unknown,
    shouldValidate?: boolean | undefined,
  ) => void,
) => {
  const days = updateDays(multidayDays, {
    pay_value: payValue,
  })
  setFieldValue('days', days)
}

const debouncedUpdatePayValueToGigDays = debounce(updatePayValueToGigDays, 300)

const updatePayValueToSingleDayShifts = (
  payValue: string,
  shifts: TSingleDayShift[],
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined,
  ) => void,
) => {
  const updatedShifts = shifts.map(shift => ({
    ...shift,
    pay_value: payValue,
  }))
  setFieldValue('single_day_shifts', updatedShifts)
}

const debouncedUpdatePayValueToSingleDayShifts = debounce(
  updatePayValueToSingleDayShifts,
  300,
)

export const handlePayRateChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  formik: FormikProps<IScheduleSectionFormValues>,
) => {
  const { setFieldValue, values } = formik

  const payValue = setNumberTo2DecimalsOnly(e.target.value)
  setFieldValue('pay_value', payValue)
  debouncedUpdatePayValueToGigDays(payValue, values.days, [], setFieldValue)
  debouncedUpdatePayValueToSingleDayShifts(
    payValue,
    values.single_day_shifts,
    setFieldValue,
  )
}
